import {
  Checkbox,
  Input,
  InputAdder,
  RadioButton,
  RadioGroup,
  Select,
} from 'components/molecules'
import { PaymentMethods } from 'components/organism'
import { useFormContext } from 'react-hook-form'
import { INPUT_TYPES } from './utils/constants'
import { processConfigWithRequiredIf } from './utils/functions'

const {
  RADIO_GROUP,
  RADIO,
  TEXT,
  DATE,
  SELECT,
  EMAIL,
  TELEPHONE,
  CHECKBOX,
  PAYMENT_METHOD,
  INPUT_ADDER,
} = INPUT_TYPES

export const DynamicControl = ({
  inputType,
  fieldName,
  defaultValue,
  options = [],
  config = {},
  isHidden = false,
  useFormContextIfAvailable = true,
  triggerError = false,
  ...rest
}) => {
  const { getValues } = useFormContext()
  const currentFormValues = getValues()
  const processedConfig = processConfigWithRequiredIf(config, currentFormValues)

  switch (inputType) {
    case TEXT:
    case DATE:
    case EMAIL:
    case TELEPHONE:
      return (
        <Input
          {...rest}
          type={inputType}
          label={fieldName}
          name={fieldName}
          defaultValue={defaultValue}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
          triggerError={triggerError}
        />
      )
    case CHECKBOX:
      return (
        <Checkbox
          {...rest}
          label={fieldName}
          name={fieldName}
          defaultValue={defaultValue}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
        />
      )
    case SELECT: {
      return (
        <Select
          {...rest}
          label={fieldName}
          name={fieldName}
          defaultValue={defaultValue}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
          triggerError={triggerError}
        />
      )
    }
    case RADIO:
      return (
        <RadioButton
          {...rest}
          name={fieldName}
          defaultValue={defaultValue}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
        />
      )
    case RADIO_GROUP:
      return (
        <RadioGroup
          disableQueryState={rest.disableQueryState}
          radioOptions={rest.radioOptions}
          defaultValue={defaultValue}
          name={fieldName}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
          radioOptionsByField={rest.radioOptionsByField}
        />
      )
    case PAYMENT_METHOD:
      return (
        <PaymentMethods
          key={fieldName}
          name={fieldName}
          isHidden={isHidden}
          config={processedConfig}
          {...rest}
        />
      )
    case INPUT_ADDER:
      return (
        <InputAdder
          {...rest}
          key={fieldName}
          label={fieldName}
          defaultValue={defaultValue}
          name={fieldName}
          isHidden={isHidden}
          config={processedConfig}
          useFormContextIfAvailable={useFormContextIfAvailable}
        />
      )
    case 'form-content':
      switch (fieldName) {
        case 'text-content':
          return
        default:
          return <span>to be done</span>
      }

    default:
      return <span>to be done</span>
  }
}
